import type { Renderable } from '@adornis/chemistry/renderable.js';
import { stateful } from '@adornis/functional-lit/stateful.js';
import { hoverTooltip } from '@adornis/popover/hover-tooltip.js';
import { html, nothing, type TemplateResult } from 'lit';
import { repeat } from 'lit/directives/repeat.js';
import { getReadableHistoryStrings } from '../../contracts/api/getReadableHistoryStrings.js';
import type { ContractSupplementApplyHistoryForPath } from '../../contracts/entities/AppliedContract.js';

const getHistoryString = (history: ContractSupplementApplyHistoryForPath) => {
  const historyStrings = getReadableHistoryStrings(history) ?? [];
  const arrow = (index: number) => (index < historyStrings.length - 1 ? html`<span> → </span>` : nothing);

  return repeat(
    historyStrings,
    (str, index) => html` <span class=${index === 0 ? 'font-bold' : ''}> ${str} </span> ${arrow(index)} `,
  );
};

export const SgFormGridEntry = stateful(
  (props: {
    label: string;
    render: Renderable | typeof nothing | (() => Renderable);
    labelAddition?: TemplateResult;
    history?: ContractSupplementApplyHistoryForPath;
    customLabelTopMargin?: string;
  }) => {
    const changed = !!props.history?.changes?.length;

    return html`
      <div class="flex flex-row justify-between ${props.customLabelTopMargin ? '' : 'items-center'}">
        <span
          class="text-sm font-semibold text-base-content/70"
          style=${props.customLabelTopMargin ? `margin-top: ${props.customLabelTopMargin}` : nothing}
        >
          ${props.label}
        </span>
        ${props.labelAddition ?? nothing}
      </div>
      <div
        class="flex flex-col rounded-field p-0.5 border-2 ${changed ? 'tooltip border-success' : 'border-transparent'}"
        ${hoverTooltip()}
      >
        ${
          changed && props.history
            ? html`
                <div class="tooltip-content">
                  <div class="flex flex-row items-center gap-2">${getHistoryString(props.history)}</div>
                </div>
              `
            : nothing
        }
        ${typeof props.render === 'function' ? props.render() : props.render}
      </div>
    `;
  },
);
